import { useViewportSize } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import type React from 'react';
import styled from 'styled-components';
import JoinCTA from '../shared/JoinCTA';

const HeaderCTA = styled(JoinCTA)`
  padding: 10px 9px;

  &:before {
    content: attr(data-text-mobile);
  }

  ${MEDIA_QUERIES.desktop`
        padding: 10px 29px;
        &:before {
            content: attr(data-text-desktop);
        }
    `}
`;
interface HeaderCtaProps {
  desktopText: string;
  mobileText: string;
  url: string;
}

export const HeaderCta: React.FC<HeaderCtaProps> = ({ mobileText, desktopText, url }) => {
  const { isMobileViewport } = useViewportSize();

  return (
    <HeaderCTA flavor="primary" glowing customUrl={url} data-event="partners_page.CTA.click">
      {isMobileViewport ? mobileText : desktopText}
    </HeaderCTA>
  );
};
